import { useCallback, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { api } from './lib/api.js';
import { useI18n } from './i18n.js';
import { LoginPage } from './pages/LoginPage.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { VehicleListPage } from './pages/VehicleListPage.js';
import { VehicleDetailPage } from './pages/VehicleDetailPage.js';
import { ImportPage } from './pages/ImportPage.js';
import { ImportHistoryPage } from './pages/ImportHistoryPage.js';

export function App() {
  const { t } = useI18n();
  const [authed, setAuthed] = useState<boolean | null>(null);

  useEffect(() => {
    api
      .me()
      .then((r) => setAuthed(r.authed))
      .catch(() => setAuthed(false));
  }, []);

  const logout = useCallback(() => {
    api.logout().finally(() => setAuthed(false));
  }, []);

  if (authed === null) {
    return <div className="login-wrap">{t('loading')}</div>;
  }
  if (!authed) {
    return <LoginPage onSuccess={() => setAuthed(true)} />;
  }

  return (
    <Layout onLogout={logout}>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/stock" element={<VehicleListPage mode="in_stock" />} />
        <Route path="/sold" element={<VehicleListPage mode="sold" />} />
        <Route path="/vehicles/:id" element={<VehicleDetailPage />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/imports" element={<ImportHistoryPage />} />
        <Route path="*" element={<div className="empty">Not found</div>} />
      </Routes>
    </Layout>
  );
}
